import { AudioWaveformIcon, RadioTowerIcon, WavesArrowDownIcon } from '@sailadv/hdata-ui';

export const PRODUCT_OPTIONS = [
	{ label: 'D.gree live', Icon: RadioTowerIcon, disabled: false },
	{ label: 'Sea trial', Icon: WavesArrowDownIcon, disabled: true },
	{ label: 'HF', Icon: AudioWaveformIcon, disabled: true },
];
